import { render, staticRenderFns } from "./UpstreamSewageWizard.vue?vue&type=template&id=b263667a&scoped=true&"
import script from "./UpstreamSewageWizard.vue?vue&type=script&lang=js&"
export * from "./UpstreamSewageWizard.vue?vue&type=script&lang=js&"
import style0 from "./UpstreamSewageWizard.vue?vue&type=style&index=0&id=b263667a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b263667a",
  null
  
)

export default component.exports